module.exports = __webpack_public_path__ + "img/ac5_thumb.3ddaa5d4.jpg";